import { firstValueFrom } from 'rxjs';
import { ReportingTransactionsBack } from '../interfaces/types';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IReportingHttpService } from '../interfaces';

@Injectable()
export class ReportingHttpService implements IReportingHttpService {
  constructor(protected httpClient: HttpClient) {}

  getReportingPartners(country: string, startDate: string, endDate: string, codeCinema = 'HO'): Promise<ReportingTransactionsBack> {
    return firstValueFrom(
      this.httpClient.get<ReportingTransactionsBack>(`/reporting/partners/${codeCinema}`, { params: { country, startDate, endDate } }),
    );
  }

  getReportingTransactions(country: string, startDate: string, endDate: string, theaterCode?: string): Promise<ReportingTransactionsBack> {
    const theater = theaterCode ? `/${theaterCode}` : '';
    return firstValueFrom(
      this.httpClient.get<ReportingTransactionsBack>(`/reporting/advanced${theater}`, {
        params: { country, startDate, endDate },
      }),
    );
  }
}
